import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GaTrackingNewsletterSubscriptionEvent implements GATrackingEvent {
  constructor(private payload: any){}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.NewsletterSubscription;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.NewsletterSubscription,
      label: this.payload.label,
      gtmCustom: {
        category: GaTrackingEventCategory.Ecommerce
      }
    };
  }
}
